import { caughtErrorLogFields, isApiError, isClientLoggedError } from "@pandas/http-client";
import logger from "@/lib/logging/logger";
import { useStore } from "@/store";

export const getErrorMessage = (e: unknown): string | undefined => {
	if (isApiError(e)) return e.errorCode;
	if (e instanceof Error) return e.message;
	return undefined;
};

export const setErrorMessage = (e: unknown, logMessage: string) => {
	const setError = useStore.getState().setError;
	// A failure the client logged above info keeps only context here. Any other
	// ApiError is an outcome the public can trigger (a mistyped partner slug
	// answers 200 with an incomplete body), so it earns warning, not error;
	// only an error the client never saw is this funnel's own error line.
	if (isClientLoggedError(e)) {
		logger.info("FLOW", logMessage, caughtErrorLogFields(e));
	} else if (isApiError(e)) {
		logger.warning("FLOW", logMessage, caughtErrorLogFields(e));
	} else {
		logger.error("FLOW", logMessage, caughtErrorLogFields(e));
	}
	setError(getErrorMessage(e));
};
